import React from 'react';

import FileInput, { IFileItem } from '../file-input/FileInput';
import MainButton from '../button/Button';
import MainCheckBox from '../checkbox/Checkbox';
import { Validation } from '../input-field/validation-helper';
import ValidationMessage from '../input-field/ValidationMessage';
import LinkTo from '../link/Link';
import { IPageContext } from '../../interfaces/pagecontext.interface';

type TPrivacyStatementText = {
  listElement: string;
};

interface Props {
  inputRef: React.RefObject<HTMLInputElement>;
  files: IFileItem[];
  isFileSizeValid: boolean;
  isFilesMaxCountValid: boolean;
  onChange: () => void;
  onChangeParagraph: () => void;
  checked: boolean;
  onItemChange: (fileName: string) => void;
  onRemove: () => void;
  validation?: Validation;
  isRequired?: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled: boolean;
  sending: boolean;
  attachmentHeadings: {
    AgreeSend: string;
    BeInformed: string;
    PrivacyLink: string;
    Purpose: string;
    AttachCV: string;
    TotalSize: string;
    RemoveSelected: string;
    AllowedTypes: string;
    HighSize: string;
    PrivacyStatementText: TPrivacyStatementText[];
    TooMuchFilesValidation: {
      Description: string;
    };
  };
  pageContext: IPageContext;
}

const Attachment = ({
  inputRef,
  files,
  isFileSizeValid,
  isFilesMaxCountValid,
  onChange,
  onChangeParagraph,
  checked,
  onItemChange,
  onRemove,
  onClick,
  disabled,
  sending,
  attachmentHeadings,
  validation,
  isRequired,
  pageContext,
}: Props) => {
  const SubmitButton = (
    <MainButton
      className="primary"
      component="button"
      type="submit"
      form="contact-form"
      onClick={onClick}
      disabled={disabled}
    >
      <span style={{ opacity: sending ? 0 : 1 }}>{attachmentHeadings.AgreeSend}</span>
      {sending && <span className="spinner3p" />}
    </MainButton>
  );

  const Information = (
    <div className="checkable-paragraph-container">
      <MainCheckBox
        className="paragraph-checkbox file-checkbox"
        id="cookies-checkbox"
        checked={checked}
        disabled={disabled}
        onChange={onChangeParagraph}
      />
      <div className="paragraph">
        <p>
          {attachmentHeadings.PrivacyStatementText[0].listElement}{' '}
          <LinkTo to="/privacy-cookies-policy" pageContext={pageContext}>
            {attachmentHeadings.PrivacyStatementText[1].listElement}
          </LinkTo>{' '}
          {attachmentHeadings.PrivacyStatementText[2].listElement}
        </p>
      </div>
      {isRequired && !validation?.isValid && <ValidationMessage text={validation!.validationMessage} />}
    </div>
  );

  const FileAttachment = (
    <FileInput
      inputRef={inputRef}
      files={files}
      onChange={onChange}
      onItemChange={onItemChange}
      onRemove={onRemove}
      isFileSizeValid={isFileSizeValid}
      isFilesMaxCountValid={isFilesMaxCountValid}
      disabled={disabled}
      attachmentHeadings={attachmentHeadings}
      contactFormRole="input"
    />
  );

  return (
    <div className="contact-attachment landing">
      {Information}
      {FileAttachment}
      {SubmitButton}
    </div>
  );
};

export default Attachment;
